import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import '@polymer/iron-ajax/iron-ajax.js';
import './login.js';
import './forget-password.js';
import './create-account.js';
import './oauth.js';
import './styles.js';
import './flex.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
class NimbusAuth extends PolymerElement {
  static get template() {
    return html`
    <style include="nimbus-flex"></style>
    <style include="nimbus-styles">
      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-Italic.eot');
        src: url('fonts/NotoSans-Italic.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-Italic.woff') format('woff'),
          url('fonts/NotoSans-Italic.ttf') format('truetype');
        font-weight: normal;
        font-style: italic;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-Bold.eot');
        src: url('fonts/NotoSans-Bold.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-Bold.woff') format('woff'),
          url('fonts/NotoSans-Bold.ttf') format('truetype');
        font-weight: bold;
        font-style: normal;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-BoldItalic.eot');
        src: url('fonts/NotoSans-BoldItalic.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-BoldItalic.woff') format('woff'),
          url('fonts/NotoSans-BoldItalic.ttf') format('truetype');
        font-weight: bold;
        font-style: italic;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans.eot');
        src: url('fonts/NotoSans.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans.woff') format('woff'),
          url('fonts/NotoSans.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
      }

      .ndsgn-icon-close {
        display: block;
        width: 24px;
        height: 24px;
        background: url(images/close.svg) no-repeat 0px 0px;
      }
      :host(.nns-theme-night) .ndsgn-icon-close {
        background: url(images/close-dark.svg) no-repeat 0px 0px;
      }
    </style>
    <div class="ndsgn-auth-form">
      <div class="ndsgn-auth-form-content">
        <div class="ndsgn-auth-form-close" flex="none" layout="row" layout-align="end center">
          <button class="ndsgn-button ndsgn-button-cleared" type="button" on-click="close">
            <span class="ndsgn-button-layout" flex="" layout="row" layout-align="center center">
              <i class="ndsgn-icon-close" flex="none"></i>
            </span>
          </button>
        </div>

        <div class="ndsgn-auth-form-inner" flex="noshrink" layout="column">
          <template is="dom-if" if="{{isShowCreateAccountForm}}" restamp>
            <nimbus-create-account-form on-create-account="onCreateAccount" class\$="{{theme}}" auth-url="{{authUrl}}"></nimbus-create-account-form>
          </template>
          <template is="dom-if" if="{{isShowSignInForm}}" restamp>
            <nimbus-login-form on-login="onLogin" class\$="{{theme}}" auth-url="{{authUrl}}"></nimbus-login-form>
          </template>
          <template is="dom-if" if="{{isShowForgetPasswordForm}}" restamp>
            <nimbus-forget-password-form class\$="{{theme}}" auth-url="{{authUrl}}"></nimbus-forget-password-form>
          </template>

          <div class="ndsgn-auth-or" flex="none">
            <div class="ndsgn-auth-form-or-layout" flex="" layout="row" layout-align="center center">
              <div class="ndsgn-auth-form-or-line" flex=""></div>
              <div class="ndsgn-auth-form-or-text">or</div>
              <div class="ndsgn-auth-form-or-line" flex=""></div>
            </div>
          </div>

          <template is="dom-if" if="{{isShowOauth}}">
            <oauth-buttons></oauth-buttons>
          </template>

          <div class="ndsgn-auth-switch" flex="none">
            <template is="dom-if" if="{{isShowCreateAccountButton}}">
              <div class="ndsgn-auth-form-actions-switch-button">
                <button class="ndsgn-button ndsgn-button-full-width ndsgn-button-text-colored" type="button" on-click="createAccount">
                  <span class="ndsgn-button-layout" flex="" layout="row" layout-align="center center">
                    CREATE NEW ACCOUNT
                  </span>
                </button>
              </div>
            </template>
            <template is="dom-if" if="{{isShowSignInButton}}">
              <div class="ndsgn-auth-form-actions-switch-button">
                <button class="ndsgn-button ndsgn-button-full-width ndsgn-button-text-colored" type="button" on-click="signIn">
                  <span class="ndsgn-button-layout" flex="" layout="row" layout-align="center center">
                    SIGN IN
                  </span>
                </button>
              </div>
            </template>
            <template is="dom-if" if="{{isShowForgetPasswordButton}}">
              <div class="ndsgn-auth-form-actions-switch-button">
                <button class="ndsgn-button ndsgn-button-full-width ndsgn-button-text-colored" type="button" on-click="forgetPassword">
                  <span class="ndsgn-button-layout" flex="" layout="row" layout-align="center center">
                    FORGOT PASSWORD
                  </span>
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <iron-ajax id="checkLoginPoll" url="{{authUrl}}/api/checklogin" handle-as="json" on-response="handleLoginPoll" on-error="handleLoginPollError" content-type="application/json"></iron-ajax>
`;
  }

  static get is() { return "nimbus-auth"; }
  static get properties() {
    return {
      'authUrl': {
        type: String
      },
      'theme': {
        type: String
      },
      'isLoggedIn': {
        type: Boolean,
        observer: '_isLoggedInChanged'
      },
      'isStopRequests': {
        type: Boolean
      },
      'showState': {
        type: Number,
        observer: '_showStateChanged'
      },
      'isShowSignInForm': Boolean,
      'isShowCreateAccountForm': Boolean,
      'isShowForgetPasswordForm': Boolean,
      'isShowSignInButton': Boolean,
      'isShowCreateAccountButton': Boolean,
      'isShowForgetPasswordButton': Boolean,
      'isShowOauth': Boolean
    }
  }

  constructor() {
    super()
  }

  loginPoll(timeout) {
    if (this.isStopRequests) return;
    setTimeout(function () {
      this.$.checkLoginPoll.generateRequest();
    }.bind(this), timeout)
  }

  handleLoginPoll() {
    let {isLoggedIn} = this.$.checkLoginPoll.lastResponse;
    if (isLoggedIn) {
      this.loginPoll(10000);
    } else {
      this.loginPoll(2500);
    }

    this.set('isLoggedIn', isLoggedIn);
  }

  handleLoginPollError() {

  }

  close() {
    const event = new CustomEvent('auth-close', {bubbles: true, composed: true});
    this.dispatchEvent(event);
  }

  onLogin() {
    this.set('isLoggedIn', true);
  }

  onCreateAccount() {
    this.set('isLoggedIn', true);
  }

  signIn() {
    this.set('showState', 0);
  }

  createAccount() {
    this.set('showState', 1);
  }

  forgetPassword() {
    this.set('showState', 2);
  }

  ready() {
    super.ready();
    this.loginPoll(1000);
    this.set('showState', 0);
  }

  _isLoggedInChanged() {
    if (this.isLoggedIn) {
      const event = new CustomEvent('login', {bubbles: true, composed: true});
      this.dispatchEvent(event);
    }
  }

  _clear() {
    this.set('isShowCreateAccountForm', false);
    this.set('isShowSignInForm', false);
    this.set('isShowForgetPasswordForm', false);
    this.set('isShowCreateAccountButton', false);
    this.set('isShowSignInButton', false);
    this.set('isShowForgetPasswordButton', false);
    this.set('isShowOauth', false);
  }

  _showStateChanged() {
    this._clear();
    if (this.showState == 0) {
      this.set('isShowSignInForm', true);
      this.set('isShowCreateAccountButton', true);
      this.set('isShowForgetPasswordButton', true);
      this.set('isShowOauth', true);
    }
    if (this.showState == 1) {
      this.set('isShowCreateAccountForm', true);
      this.set('isShowSignInButton', true);
      this.set('isShowForgetPasswordButton', true);
      this.set('isShowOauth', false);
    }
    if (this.showState == 2) {
      this.set('isShowForgetPasswordForm', true);
      this.set('isShowCreateAccountButton', true);
      this.set('isShowSignInButton', true);
      this.set('isShowOauth', true);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.set('isStopRequests', true);
  }
}
window.addEventListener('message', function (e) {
  if(e.data && e.data.a == "openid-auth-completed") {
    const event = new CustomEvent('login', {bubbles: true, composed: true});
  }
})
customElements.define(NimbusAuth.is, NimbusAuth);
